module.exports = __webpack_public_path__ + "img/Success.a21bc948.svg";